export function isHKData(data) {
  return data.startDate !== undefined;
}
export var HKCategoryMensValue = /*#__PURE__*/function (HKCategoryMensValue) {
  HKCategoryMensValue[HKCategoryMensValue["UNSPECIFIED"] = 1] = "UNSPECIFIED";
  HKCategoryMensValue[HKCategoryMensValue["LIGHT"] = 2] = "LIGHT";
  HKCategoryMensValue[HKCategoryMensValue["MEDIUM"] = 3] = "MEDIUM";
  HKCategoryMensValue[HKCategoryMensValue["HEAVY"] = 4] = "HEAVY";
  HKCategoryMensValue[HKCategoryMensValue["NO_FLOW"] = 5] = "NO_FLOW";
  return HKCategoryMensValue;
}(HKCategoryMensValue || {});
export var HKCategoryLHTestValue = /*#__PURE__*/function (HKCategoryLHTestValue) {
  HKCategoryLHTestValue[HKCategoryLHTestValue["NEGATIVE"] = 1] = "NEGATIVE";
  HKCategoryLHTestValue[HKCategoryLHTestValue["POSITIVE"] = 2] = "POSITIVE";
  HKCategoryLHTestValue[HKCategoryLHTestValue["INDETERMINATE"] = 3] = "INDETERMINATE";
  return HKCategoryLHTestValue;
}(HKCategoryLHTestValue || {});
export var HKCategoryCervicalMucusValue = /*#__PURE__*/function (HKCategoryCervicalMucusValue) {
  HKCategoryCervicalMucusValue[HKCategoryCervicalMucusValue["DRY"] = 1] = "DRY";
  HKCategoryCervicalMucusValue[HKCategoryCervicalMucusValue["STICKY"] = 2] = "STICKY";
  HKCategoryCervicalMucusValue[HKCategoryCervicalMucusValue["CREAMY"] = 3] = "CREAMY";
  HKCategoryCervicalMucusValue[HKCategoryCervicalMucusValue["WATERY"] = 4] = "WATERY";
  HKCategoryCervicalMucusValue[HKCategoryCervicalMucusValue["EGGWHITE"] = 5] = "EGGWHITE";
  return HKCategoryCervicalMucusValue;
}(HKCategoryCervicalMucusValue || {});